document.addEventListener('DOMContentLoaded', () => {
  const body = document.body;
  const header = document.querySelector('.gl-header');
  const catNav = document.getElementById('kara-grid');
  const gridA = document.getElementById('grid-a');
  const gridB = document.getElementById('grid-b');
  const observationGrid = document.getElementById('observation-grid');
  const quietZoomWrap = document.getElementById('quiet-zoom-wrap');
  const quietZoomImg = document.querySelector('#quiet-zoom-wrap .quietzoom-image');
  const quietZoomStage = document.getElementById('quiet-zoom-stage');
  const quietZoomLabel = document.getElementById('quiet-zoom-label');
  const karaReveal = document.getElementById('kara-reveal');
  const karaBg = document.getElementById('kara-bg');

  const STAGES = ['FAR', 'CLOSER', 'CLOSER', 'CLOSE'];

  function onScroll() {
    if (header) header.classList.toggle('scrolled', window.scrollY > 80);

    if (quietZoomWrap && quietZoomImg) {
      const r = quietZoomWrap.getBoundingClientRect();
      const vh = window.innerHeight || 800;
      const total = r.height - vh;
      const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      const scale = 1 + p * 1.9;
      // Focus = embroidered pocket. Pull it toward a point BELOW viewport center
      // so it sits under the fixed "LOOK CLOSER." label (label stays put).
      const isMobile =
        (document.body.getAttribute('data-mode') === 'mobile') ||
        window.matchMedia('(max-width: 749px)').matches;
      const fx = parseFloat(
        (isMobile ? quietZoomWrap.dataset.focusXMobile : quietZoomWrap.dataset.focusX) ||
          '60'
      ) / 100;
      const fy = parseFloat(
        (isMobile ? quietZoomWrap.dataset.focusYMobile : quietZoomWrap.dataset.focusY) ||
          (isMobile ? '30' : '24')
      ) / 100;
      const anchorX = 0.5;
      // Below center — clears the centered LOOK CLOSER text
      const anchorY = isMobile ? 0.66 : 0.85;
      const tx = (anchorX - fx) * (1 - 1 / scale) * 100;
      const ty = (anchorY - fy) * (1 - 1 / scale) * 100;
      quietZoomImg.style.transformOrigin = `${fx * 100}% ${fy * 100}%`;
      quietZoomImg.style.transform = `translate(${tx.toFixed(3)}%, ${ty.toFixed(3)}%) scale(${scale})`;
      const stageIdx = Math.min(3, Math.floor(p * 4));
      if (quietZoomStage) quietZoomStage.textContent = STAGES[stageIdx];
      if (quietZoomLabel) quietZoomLabel.style.opacity = p > 0.82 ? '1' : '0';
    }

    if (karaReveal && karaBg) {
      const r = karaReveal.getBoundingClientRect();
      const vh = window.innerHeight || 800;
      const center = r.top + r.height / 2;
      const dist = Math.abs(center - vh / 2);
      const maxDist = vh / 2 + r.height / 2;
      const p = Math.min(1, Math.max(0, 1 - dist / maxDist));
      karaBg.style.opacity = (0.05 + p * 0.55).toFixed(3);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  // desktop/mobile toggle
  document.querySelectorAll('.gl-view-toggle button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const mode = btn.dataset.mode;
      body.setAttribute('data-mode', mode);
      document.querySelectorAll('.gl-view-toggle button').forEach((b) => b.classList.toggle('active', b === btn));
    });
  });

  // scroll-to-grid links
  document.querySelectorAll('.gl-scroll-to-grid').forEach((a) => {
    a.addEventListener('click', (e) => {
      e.preventDefault();
      const el = document.getElementById('kara-grid');
      if (el) window.scrollTo({ top: el.getBoundingClientRect().top + window.scrollY - 8, behavior: 'smooth' });
    });
  });

  // category filter
  const cards = Array.from(document.querySelectorAll('#grid-a .gl-card, #grid-b .gl-card'));

  function isKaraPage() {
    return body.classList.contains('template_kara-page') || body.classList.contains('template_kara-pdp-new');
  }

  function isKaraMobile() {
    return isKaraPage() && (
      window.matchMedia('(max-width: 749px)').matches ||
      body.getAttribute('data-mode') === 'mobile'
    );
  }

  function distributeKaraRows() {
    if (!gridA || !isKaraPage()) return;
    const wrap = gridA.querySelector('.gl-grid-rows');
    if (!isKaraMobile()) {
      if (wrap) {
        cards.forEach((card) => gridA.appendChild(card));
        wrap.remove();
      }
      return;
    }
    let rowsWrap = wrap;
    if (!rowsWrap) {
      rowsWrap = document.createElement('div');
      rowsWrap.className = 'gl-grid-rows';
      for (let i = 0; i < 3; i++) {
        const row = document.createElement('div');
        row.className = 'gl-grid-row gl-no-scrollbar';
        rowsWrap.appendChild(row);
      }
      gridA.appendChild(rowsWrap);
    }
    const rows = Array.from(rowsWrap.children);
    const visible = cards.filter((card) => card.style.display !== 'none');
    const hidden = cards.filter((card) => card.style.display === 'none');
    const chunk = Math.ceil(visible.length / 3) || 1;
    visible.forEach((card, i) => {
      rows[Math.min(2, Math.floor(i / chunk))].appendChild(card);
    });
    hidden.forEach((card) => rows[0].appendChild(card));
  }
  window.glDistributeKaraRows = distributeKaraRows;

  document.querySelectorAll('.gl-cat-nav button').forEach((btn) => {
    btn.addEventListener('click', () => {
      const cat = (btn.dataset.cat || '').toLowerCase();
      document.querySelectorAll('.gl-cat-nav button').forEach((b) => b.classList.toggle('active', b === btn));
      let visible = [];
      cards.forEach((card) => {
        const cats = (card.dataset.category || '')
          .split(',')
          .map((item) => item.trim().toLowerCase())
          .filter(Boolean);
        const show = cat === 'all' || cats.includes(cat);
        card.style.display = show ? '' : 'none';
        if (show) visible.push(card);
      });
      // redistribute visible cards across grid A (first 6) / grid B (rest)
      visible.forEach((card, i) => {
        const target = i < 6 ? gridA : gridB;
        if (target) target.appendChild(card);
      });
      const colsA = Math.max(3, Math.min(3, Math.min(6, visible.length)));
      const colsB = Math.max(3, Math.min(3, Math.max(0, visible.length - 6)));
      if (window.matchMedia('(min-width:1px)').matches && body.getAttribute('data-mode') !== 'mobile') {
        gridA.style.gridTemplateColumns = `repeat(${colsA},minmax(0,360px))`;
        gridB.style.gridTemplateColumns = `repeat(${colsB || 1},minmax(0,360px))`;
        gridB.style.display = colsB ? 'grid' : 'none';
      }
      distributeKaraRows();
    });
  });

  // swatch clicks per card
  document.querySelectorAll('.gl-card').forEach((card) => {
    const media = card.querySelector('.gl-card-media image-slot');
    const imagesAttr = card.dataset.images;
    const images = imagesAttr ? imagesAttr.split('|') : [];
    card.querySelectorAll('.gl-swatch').forEach((sw, i) => {
      sw.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        card.querySelectorAll('.gl-swatch').forEach((s) => s.classList.remove('active'));
        sw.classList.add('active');
        if (images[i] && media) media.setAttribute('src', images[i]);
      });
    });
  });

  // mobile autoscroll for horizontal grids (Kara collection uses independent rows)
  const autoScrollEls = (isKaraPage() ? [observationGrid] : [gridA, gridB, observationGrid]).filter(Boolean);
  setInterval(() => {
    if (body.getAttribute('data-mode') !== 'mobile') return;
    autoScrollEls.forEach((el) => {
      const max = el.scrollWidth - el.clientWidth;
      if (max <= 0) return;
      el.scrollLeft += 0.6;
      if (el.scrollLeft >= max - 1) el.scrollLeft = 0;
    });
  }, 30);

  distributeKaraRows();
  window.addEventListener('resize', distributeKaraRows);
});

document.addEventListener('DOMContentLoaded', () => {
  const tmpl = document.getElementById('gl-card-template');
  const gridA = document.getElementById('grid-a');
  const gridB = document.getElementById('grid-b');
  if (!tmpl || !gridA || !gridB || typeof PRODUCTS === 'undefined') return;

  PRODUCTS.forEach((p, idx) => {
    const node = tmpl.content.cloneNode(true);
    const a = node.querySelector('.gl-card');
    a.href = `product.html?slug=${p.slug}`;
    a.dataset.category = p.category;
    a.dataset.images = (p.images || [p.src]).join('|');

    const media = node.querySelector('.gl-card-media image-slot');
    media.setAttribute('placeholder', p.name);
    if (p.src) media.setAttribute('src', p.src);

    node.querySelector('.gl-card-name').textContent = p.name;
    node.querySelector('.gl-card-price').textContent = p.price;

    const swWrap = node.querySelector('.gl-card-swatches');
    (p.colours || []).forEach((hex, i) => {
      const b = document.createElement('button');
      b.className = 'gl-swatch' + (i === 0 ? ' active' : '');
      b.style.background = hex;
      swWrap.appendChild(b);
    });

    (idx < 6 ? gridA : gridB).appendChild(node);
  });
});

const PRODUCTS = [
  { slug:'workwear-shirt', name:'WORKWEAR SHIRT', category:'SHIRTS', colours:['#000000','#522C18','#2B3240'], price:'₹4,600', src:'./assets/product/workwear-shirt-black.png', images:['./assets/product/workwear-shirt-black.png','./assets/placeholder/bw-field-portrait.jpg','./assets/placeholder/wheat-field-motion.jpg'] },
  { slug:'cross-collar-shirt', name:'CROSS-COLLAR SHIRT', category:'SHIRTS', colours:['#9C7655','#D8B65E','#4B5641'], price:'₹4,400', src:'./assets/product/cross-collar-shirt-brown.png', images:['./assets/product/cross-collar-shirt-brown.png','./assets/placeholder/office-suit-seated.jpg','./assets/placeholder/street-two-people-flowers.jpg'] },
  { slug:'deconstructed-shirt', name:'DECONSTRUCTED SHIRT', category:'SHIRTS', colours:['#000000','#A9C4D4','#D8B65E'], price:'₹4,300', src:'./assets/product/deconstructed-shirt-black.png', images:['./assets/product/deconstructed-shirt-black.png','./assets/placeholder/bw-field-portrait.jpg','./assets/placeholder/field-two-women.jpg'] },
  { slug:'saddle-stitch-shirt', name:'SADDLE-STITCH SHIRT', category:'SHIRTS', colours:['#522C18','#B98B5E','#A9C4D4'], price:'₹4,500', src:'./assets/product/saddle-shirt-dark-brown.png', images:['./assets/product/saddle-shirt-dark-brown.png','./assets/placeholder/office-suit-seated.jpg','./assets/placeholder/wheat-field-motion.jpg'] },
  { slug:'toggle-shacket', name:'TOGGLE SHACKET', category:'SHACKETS', colours:['#4B5641','#2B3240','#D8B65E'], price:'₹7,000', src:'./assets/product/toggle-shacket-olive.png', images:['./assets/product/toggle-shacket-olive.png','./assets/placeholder/wheat-field-motion.jpg','./assets/placeholder/bw-field-portrait.jpg'] },
  { slug:'utility-shacket', name:'UTILITY SHACKET', category:'SHACKETS', colours:['#000000','#A9C4D4','#522C18'], price:'₹7,200', src:'./assets/product/utility-shacket-black.png', images:['./assets/product/utility-shacket-black.png','./assets/placeholder/street-two-people-flowers.jpg','./assets/placeholder/field-two-women.jpg'] },
  { slug:'pleat-trouser', name:'PLEAT TROUSER', category:'TROUSERS', colours:['#2B3240','#522C18','#000000'], price:'₹3,900', src:'./assets/product/pleat-trouser-navy.png', images:['./assets/product/pleat-trouser-navy.png','./assets/placeholder/office-suit-seated.jpg','./assets/placeholder/bw-field-portrait.jpg'] },
  { slug:'pintuck-pant', name:'PINTUCK PANT', category:'TROUSERS', colours:['#522C18','#000000','#4B5641'], price:'₹3,800', src:'./assets/product/pintuck-pant-dark-brown.png', images:['./assets/product/pintuck-pant-dark-brown.png','./assets/placeholder/wheat-field-motion.jpg','./assets/placeholder/street-two-people-flowers.jpg'] },
  { slug:'kara-01-sneaker-men', name:'KARA 01 SNEAKER — MEN', category:'SHOES', colours:['#000000','#522C18','#F1EEEA'], price:'₹5,200' },
  { slug:'kara-01-sneaker-women', name:'KARA 01 SNEAKER — WOMEN', category:'SHOES', colours:['#000000','#9C7655','#F1EEEA'], price:'₹5,200' },
];